import { CookieStorage } from "amazon-cognito-identity-js";

//detcting i frame
const isInIframe = typeof window !== "undefined" && window.self !== window.top;

const storage = !isInIframe
  ? new CookieStorage({
      ...(process.env.REACT_APP_AWS_COOKIE_KEY
        ? { domain: process.env.REACT_APP_AWS_COOKIE_KEY }
        : {}),
    })
  : undefined;

const COGNITO_STORAGE_OBJECT = storage ? { Storage: storage } : {};

const AWSCognitoPoolData = {
  UserPoolId: process.env.REACT_APP_AWS_COGNITO_POOL,
  ClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT,
  ...COGNITO_STORAGE_OBJECT,
};

export { AWSCognitoPoolData, COGNITO_STORAGE_OBJECT };
